/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as AdminIndexRouteImport } from './routes/_admin/index'
import { Route as AdminUsersRouteImport } from './routes/_admin/users'
import { Route as AdminTopicsIndexRouteImport } from './routes/_admin/topics.index'
import { Route as AdminStudyHelpersIndexRouteImport } from './routes/_admin/study-helpers.index'
import { Route as AdminStudentsIndexRouteImport } from './routes/_admin/students.index'
import { Route as AdminSeriesIndexRouteImport } from './routes/_admin/series.index'
import { Route as AdminQuizSubmissionsIndexRouteImport } from './routes/_admin/quiz-submissions.index'
import { Route as AdminQuestionsIndexRouteImport } from './routes/_admin/questions.index'
import { Route as AdminOnboardingsIndexRouteImport } from './routes/_admin/onboardings.index'
import { Route as AdminOnboardingSlidesIndexRouteImport } from './routes/_admin/onboarding-slides.index'
import { Route as AdminLessonsIndexRouteImport } from './routes/_admin/lessons.index'
import { Route as AdminGroupsIndexRouteImport } from './routes/_admin/groups.index'
import { Route as AdminFeedbacksIndexRouteImport } from './routes/_admin/feedbacks.index'
import { Route as AdminCoursesIndexRouteImport } from './routes/_admin/courses.index'
import { Route as AdminCertificatesIndexRouteImport } from './routes/_admin/certificates.index'
import { Route as AdminCampaignsIndexRouteImport } from './routes/_admin/campaigns.index'
import { Route as AdminApplicationsIndexRouteImport } from './routes/_admin/applications.index'
import { Route as AdminTopicsTopicIdRouteImport } from './routes/_admin/topics.$topicId'
import { Route as AdminStudyHelpersStudyHelperIdRouteImport } from './routes/_admin/study-helpers.$studyHelperId'
import { Route as AdminStudentsStudentIdRouteImport } from './routes/_admin/students.$studentId'
import { Route as AdminSeriesSeriesIdRouteImport } from './routes/_admin/series.$seriesId'
import { Route as AdminQuizSubmissionsSubmissionIdRouteImport } from './routes/_admin/quiz-submissions.$submissionId'
import { Route as AdminQuestionsQuestionIdRouteImport } from './routes/_admin/questions.$questionId'
import { Route as AdminOnboardingsOnboardingIdRouteImport } from './routes/_admin/onboardings.$onboardingId'
import { Route as AdminLessonsLessonIdRouteImport } from './routes/_admin/lessons.$lessonId'
import { Route as AdminGroupsGroupIdRouteImport } from './routes/_admin/groups.$groupId'
import { Route as AdminFeedbacksSubmissionIdRouteImport } from './routes/_admin/feedbacks.$submissionId'
import { Route as AdminCampaignsCampaignIdRouteImport } from './routes/_admin/campaigns.$campaignId'
import { Route as AdminApplicationsApplicationIdRouteImport } from './routes/_admin/applications.$applicationId'
import { Route as AdminOnboardingSlidesOnboardingIdSlideIndexRouteImport } from './routes/_admin/onboarding-slides.$onboardingId.$slideIndex'
import { Route as AdminCoursesCourseIdVersionRouteImport } from './routes/_admin/courses.$courseId.$version'

const AdminRoute = AdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTopicsIndexRoute = AdminTopicsIndexRouteImport.update({
  id: '/topics/',
  path: '/topics/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStudyHelpersIndexRoute = AdminStudyHelpersIndexRouteImport.update({
  id: '/study-helpers/',
  path: '/study-helpers/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStudentsIndexRoute = AdminStudentsIndexRouteImport.update({
  id: '/students/',
  path: '/students/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSeriesIndexRoute = AdminSeriesIndexRouteImport.update({
  id: '/series/',
  path: '/series/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminQuizSubmissionsIndexRoute =
  AdminQuizSubmissionsIndexRouteImport.update({
    id: '/quiz-submissions/',
    path: '/quiz-submissions/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminQuestionsIndexRoute = AdminQuestionsIndexRouteImport.update({
  id: '/questions/',
  path: '/questions/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOnboardingsIndexRoute = AdminOnboardingsIndexRouteImport.update({
  id: '/onboardings/',
  path: '/onboardings/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOnboardingSlidesIndexRoute =
  AdminOnboardingSlidesIndexRouteImport.update({
    id: '/onboarding-slides/',
    path: '/onboarding-slides/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminLessonsIndexRoute = AdminLessonsIndexRouteImport.update({
  id: '/lessons/',
  path: '/lessons/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminGroupsIndexRoute = AdminGroupsIndexRouteImport.update({
  id: '/groups/',
  path: '/groups/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeedbacksIndexRoute = AdminFeedbacksIndexRouteImport.update({
  id: '/feedbacks/',
  path: '/feedbacks/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCoursesIndexRoute = AdminCoursesIndexRouteImport.update({
  id: '/courses/',
  path: '/courses/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCertificatesIndexRoute = AdminCertificatesIndexRouteImport.update({
  id: '/certificates/',
  path: '/certificates/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCampaignsIndexRoute = AdminCampaignsIndexRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminApplicationsIndexRoute = AdminApplicationsIndexRouteImport.update({
  id: '/applications/',
  path: '/applications/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTopicsTopicIdRoute = AdminTopicsTopicIdRouteImport.update({
  id: '/topics/$topicId',
  path: '/topics/$topicId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStudyHelpersStudyHelperIdRoute =
  AdminStudyHelpersStudyHelperIdRouteImport.update({
    id: '/study-helpers/$studyHelperId',
    path: '/study-helpers/$studyHelperId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminStudentsStudentIdRoute = AdminStudentsStudentIdRouteImport.update({
  id: '/students/$studentId',
  path: '/students/$studentId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSeriesSeriesIdRoute = AdminSeriesSeriesIdRouteImport.update({
  id: '/series/$seriesId',
  path: '/series/$seriesId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminQuizSubmissionsSubmissionIdRoute =
  AdminQuizSubmissionsSubmissionIdRouteImport.update({
    id: '/quiz-submissions/$submissionId',
    path: '/quiz-submissions/$submissionId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminQuestionsQuestionIdRoute =
  AdminQuestionsQuestionIdRouteImport.update({
    id: '/questions/$questionId',
    path: '/questions/$questionId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminOnboardingsOnboardingIdRoute =
  AdminOnboardingsOnboardingIdRouteImport.update({
    id: '/onboardings/$onboardingId',
    path: '/onboardings/$onboardingId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminLessonsLessonIdRoute = AdminLessonsLessonIdRouteImport.update({
  id: '/lessons/$lessonId',
  path: '/lessons/$lessonId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminGroupsGroupIdRoute = AdminGroupsGroupIdRouteImport.update({
  id: '/groups/$groupId',
  path: '/groups/$groupId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeedbacksSubmissionIdRoute =
  AdminFeedbacksSubmissionIdRouteImport.update({
    id: '/feedbacks/$submissionId',
    path: '/feedbacks/$submissionId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCampaignsCampaignIdRoute =
  AdminCampaignsCampaignIdRouteImport.update({
    id: '/campaigns/$campaignId',
    path: '/campaigns/$campaignId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminApplicationsApplicationIdRoute =
  AdminApplicationsApplicationIdRouteImport.update({
    id: '/applications/$applicationId',
    path: '/applications/$applicationId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminOnboardingSlidesOnboardingIdSlideIndexRoute =
  AdminOnboardingSlidesOnboardingIdSlideIndexRouteImport.update({
    id: '/onboarding-slides/$onboardingId/$slideIndex',
    path: '/onboarding-slides/$onboardingId/$slideIndex',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCoursesCourseIdVersionRoute =
  AdminCoursesCourseIdVersionRouteImport.update({
    id: '/courses/$courseId/$version',
    path: '/courses/$courseId/$version',
    getParentRoute: () => AdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/users': typeof AdminUsersRoute
  '/': typeof AdminIndexRoute
  '/applications/$applicationId': typeof AdminApplicationsApplicationIdRoute
  '/campaigns/$campaignId': typeof AdminCampaignsCampaignIdRoute
  '/feedbacks/$submissionId': typeof AdminFeedbacksSubmissionIdRoute
  '/groups/$groupId': typeof AdminGroupsGroupIdRoute
  '/lessons/$lessonId': typeof AdminLessonsLessonIdRoute
  '/onboardings/$onboardingId': typeof AdminOnboardingsOnboardingIdRoute
  '/questions/$questionId': typeof AdminQuestionsQuestionIdRoute
  '/quiz-submissions/$submissionId': typeof AdminQuizSubmissionsSubmissionIdRoute
  '/series/$seriesId': typeof AdminSeriesSeriesIdRoute
  '/students/$studentId': typeof AdminStudentsStudentIdRoute
  '/study-helpers/$studyHelperId': typeof AdminStudyHelpersStudyHelperIdRoute
  '/topics/$topicId': typeof AdminTopicsTopicIdRoute
  '/applications': typeof AdminApplicationsIndexRoute
  '/campaigns': typeof AdminCampaignsIndexRoute
  '/certificates': typeof AdminCertificatesIndexRoute
  '/courses': typeof AdminCoursesIndexRoute
  '/feedbacks': typeof AdminFeedbacksIndexRoute
  '/groups': typeof AdminGroupsIndexRoute
  '/lessons': typeof AdminLessonsIndexRoute
  '/onboarding-slides': typeof AdminOnboardingSlidesIndexRoute
  '/onboardings': typeof AdminOnboardingsIndexRoute
  '/questions': typeof AdminQuestionsIndexRoute
  '/quiz-submissions': typeof AdminQuizSubmissionsIndexRoute
  '/series': typeof AdminSeriesIndexRoute
  '/students': typeof AdminStudentsIndexRoute
  '/study-helpers': typeof AdminStudyHelpersIndexRoute
  '/topics': typeof AdminTopicsIndexRoute
  '/courses/$courseId/$version': typeof AdminCoursesCourseIdVersionRoute
  '/onboarding-slides/$onboardingId/$slideIndex': typeof AdminOnboardingSlidesOnboardingIdSlideIndexRoute
}
export interface FileRoutesByTo {
  '/users': typeof AdminUsersRoute
  '/': typeof AdminIndexRoute
  '/applications/$applicationId': typeof AdminApplicationsApplicationIdRoute
  '/campaigns/$campaignId': typeof AdminCampaignsCampaignIdRoute
  '/feedbacks/$submissionId': typeof AdminFeedbacksSubmissionIdRoute
  '/groups/$groupId': typeof AdminGroupsGroupIdRoute
  '/lessons/$lessonId': typeof AdminLessonsLessonIdRoute
  '/onboardings/$onboardingId': typeof AdminOnboardingsOnboardingIdRoute
  '/questions/$questionId': typeof AdminQuestionsQuestionIdRoute
  '/quiz-submissions/$submissionId': typeof AdminQuizSubmissionsSubmissionIdRoute
  '/series/$seriesId': typeof AdminSeriesSeriesIdRoute
  '/students/$studentId': typeof AdminStudentsStudentIdRoute
  '/study-helpers/$studyHelperId': typeof AdminStudyHelpersStudyHelperIdRoute
  '/topics/$topicId': typeof AdminTopicsTopicIdRoute
  '/applications': typeof AdminApplicationsIndexRoute
  '/campaigns': typeof AdminCampaignsIndexRoute
  '/certificates': typeof AdminCertificatesIndexRoute
  '/courses': typeof AdminCoursesIndexRoute
  '/feedbacks': typeof AdminFeedbacksIndexRoute
  '/groups': typeof AdminGroupsIndexRoute
  '/lessons': typeof AdminLessonsIndexRoute
  '/onboarding-slides': typeof AdminOnboardingSlidesIndexRoute
  '/onboardings': typeof AdminOnboardingsIndexRoute
  '/questions': typeof AdminQuestionsIndexRoute
  '/quiz-submissions': typeof AdminQuizSubmissionsIndexRoute
  '/series': typeof AdminSeriesIndexRoute
  '/students': typeof AdminStudentsIndexRoute
  '/study-helpers': typeof AdminStudyHelpersIndexRoute
  '/topics': typeof AdminTopicsIndexRoute
  '/courses/$courseId/$version': typeof AdminCoursesCourseIdVersionRoute
  '/onboarding-slides/$onboardingId/$slideIndex': typeof AdminOnboardingSlidesOnboardingIdSlideIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_admin': typeof AdminRouteWithChildren
  '/_admin/users': typeof AdminUsersRoute
  '/_admin/': typeof AdminIndexRoute
  '/_admin/applications/$applicationId': typeof AdminApplicationsApplicationIdRoute
  '/_admin/campaigns/$campaignId': typeof AdminCampaignsCampaignIdRoute
  '/_admin/feedbacks/$submissionId': typeof AdminFeedbacksSubmissionIdRoute
  '/_admin/groups/$groupId': typeof AdminGroupsGroupIdRoute
  '/_admin/lessons/$lessonId': typeof AdminLessonsLessonIdRoute
  '/_admin/onboardings/$onboardingId': typeof AdminOnboardingsOnboardingIdRoute
  '/_admin/questions/$questionId': typeof AdminQuestionsQuestionIdRoute
  '/_admin/quiz-submissions/$submissionId': typeof AdminQuizSubmissionsSubmissionIdRoute
  '/_admin/series/$seriesId': typeof AdminSeriesSeriesIdRoute
  '/_admin/students/$studentId': typeof AdminStudentsStudentIdRoute
  '/_admin/study-helpers/$studyHelperId': typeof AdminStudyHelpersStudyHelperIdRoute
  '/_admin/topics/$topicId': typeof AdminTopicsTopicIdRoute
  '/_admin/applications/': typeof AdminApplicationsIndexRoute
  '/_admin/campaigns/': typeof AdminCampaignsIndexRoute
  '/_admin/certificates/': typeof AdminCertificatesIndexRoute
  '/_admin/courses/': typeof AdminCoursesIndexRoute
  '/_admin/feedbacks/': typeof AdminFeedbacksIndexRoute
  '/_admin/groups/': typeof AdminGroupsIndexRoute
  '/_admin/lessons/': typeof AdminLessonsIndexRoute
  '/_admin/onboarding-slides/': typeof AdminOnboardingSlidesIndexRoute
  '/_admin/onboardings/': typeof AdminOnboardingsIndexRoute
  '/_admin/questions/': typeof AdminQuestionsIndexRoute
  '/_admin/quiz-submissions/': typeof AdminQuizSubmissionsIndexRoute
  '/_admin/series/': typeof AdminSeriesIndexRoute
  '/_admin/students/': typeof AdminStudentsIndexRoute
  '/_admin/study-helpers/': typeof AdminStudyHelpersIndexRoute
  '/_admin/topics/': typeof AdminTopicsIndexRoute
  '/_admin/courses/$courseId/$version': typeof AdminCoursesCourseIdVersionRoute
  '/_admin/onboarding-slides/$onboardingId/$slideIndex': typeof AdminOnboardingSlidesOnboardingIdSlideIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/users'
    | '/'
    | '/applications/$applicationId'
    | '/campaigns/$campaignId'
    | '/feedbacks/$submissionId'
    | '/groups/$groupId'
    | '/lessons/$lessonId'
    | '/onboardings/$onboardingId'
    | '/questions/$questionId'
    | '/quiz-submissions/$submissionId'
    | '/series/$seriesId'
    | '/students/$studentId'
    | '/study-helpers/$studyHelperId'
    | '/topics/$topicId'
    | '/applications'
    | '/campaigns'
    | '/certificates'
    | '/courses'
    | '/feedbacks'
    | '/groups'
    | '/lessons'
    | '/onboarding-slides'
    | '/onboardings'
    | '/questions'
    | '/quiz-submissions'
    | '/series'
    | '/students'
    | '/study-helpers'
    | '/topics'
    | '/courses/$courseId/$version'
    | '/onboarding-slides/$onboardingId/$slideIndex'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/users'
    | '/'
    | '/applications/$applicationId'
    | '/campaigns/$campaignId'
    | '/feedbacks/$submissionId'
    | '/groups/$groupId'
    | '/lessons/$lessonId'
    | '/onboardings/$onboardingId'
    | '/questions/$questionId'
    | '/quiz-submissions/$submissionId'
    | '/series/$seriesId'
    | '/students/$studentId'
    | '/study-helpers/$studyHelperId'
    | '/topics/$topicId'
    | '/applications'
    | '/campaigns'
    | '/certificates'
    | '/courses'
    | '/feedbacks'
    | '/groups'
    | '/lessons'
    | '/onboarding-slides'
    | '/onboardings'
    | '/questions'
    | '/quiz-submissions'
    | '/series'
    | '/students'
    | '/study-helpers'
    | '/topics'
    | '/courses/$courseId/$version'
    | '/onboarding-slides/$onboardingId/$slideIndex'
  id:
    | '__root__'
    | '/_admin'
    | '/_admin/users'
    | '/_admin/'
    | '/_admin/applications/$applicationId'
    | '/_admin/campaigns/$campaignId'
    | '/_admin/feedbacks/$submissionId'
    | '/_admin/groups/$groupId'
    | '/_admin/lessons/$lessonId'
    | '/_admin/onboardings/$onboardingId'
    | '/_admin/questions/$questionId'
    | '/_admin/quiz-submissions/$submissionId'
    | '/_admin/series/$seriesId'
    | '/_admin/students/$studentId'
    | '/_admin/study-helpers/$studyHelperId'
    | '/_admin/topics/$topicId'
    | '/_admin/applications/'
    | '/_admin/campaigns/'
    | '/_admin/certificates/'
    | '/_admin/courses/'
    | '/_admin/feedbacks/'
    | '/_admin/groups/'
    | '/_admin/lessons/'
    | '/_admin/onboarding-slides/'
    | '/_admin/onboardings/'
    | '/_admin/questions/'
    | '/_admin/quiz-submissions/'
    | '/_admin/series/'
    | '/_admin/students/'
    | '/_admin/study-helpers/'
    | '/_admin/topics/'
    | '/_admin/courses/$courseId/$version'
    | '/_admin/onboarding-slides/$onboardingId/$slideIndex'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AdminRoute: typeof AdminRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin/': {
      id: '/_admin/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/users': {
      id: '/_admin/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/topics/': {
      id: '/_admin/topics/'
      path: '/topics'
      fullPath: '/topics'
      preLoaderRoute: typeof AdminTopicsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/study-helpers/': {
      id: '/_admin/study-helpers/'
      path: '/study-helpers'
      fullPath: '/study-helpers'
      preLoaderRoute: typeof AdminStudyHelpersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/students/': {
      id: '/_admin/students/'
      path: '/students'
      fullPath: '/students'
      preLoaderRoute: typeof AdminStudentsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/series/': {
      id: '/_admin/series/'
      path: '/series'
      fullPath: '/series'
      preLoaderRoute: typeof AdminSeriesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/quiz-submissions/': {
      id: '/_admin/quiz-submissions/'
      path: '/quiz-submissions'
      fullPath: '/quiz-submissions'
      preLoaderRoute: typeof AdminQuizSubmissionsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/questions/': {
      id: '/_admin/questions/'
      path: '/questions'
      fullPath: '/questions'
      preLoaderRoute: typeof AdminQuestionsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/onboardings/': {
      id: '/_admin/onboardings/'
      path: '/onboardings'
      fullPath: '/onboardings'
      preLoaderRoute: typeof AdminOnboardingsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/onboarding-slides/': {
      id: '/_admin/onboarding-slides/'
      path: '/onboarding-slides'
      fullPath: '/onboarding-slides'
      preLoaderRoute: typeof AdminOnboardingSlidesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/lessons/': {
      id: '/_admin/lessons/'
      path: '/lessons'
      fullPath: '/lessons'
      preLoaderRoute: typeof AdminLessonsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/groups/': {
      id: '/_admin/groups/'
      path: '/groups'
      fullPath: '/groups'
      preLoaderRoute: typeof AdminGroupsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/feedbacks/': {
      id: '/_admin/feedbacks/'
      path: '/feedbacks'
      fullPath: '/feedbacks'
      preLoaderRoute: typeof AdminFeedbacksIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/courses/': {
      id: '/_admin/courses/'
      path: '/courses'
      fullPath: '/courses'
      preLoaderRoute: typeof AdminCoursesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/certificates/': {
      id: '/_admin/certificates/'
      path: '/certificates'
      fullPath: '/certificates'
      preLoaderRoute: typeof AdminCertificatesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/campaigns/': {
      id: '/_admin/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof AdminCampaignsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/applications/': {
      id: '/_admin/applications/'
      path: '/applications'
      fullPath: '/applications'
      preLoaderRoute: typeof AdminApplicationsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/topics/$topicId': {
      id: '/_admin/topics/$topicId'
      path: '/topics/$topicId'
      fullPath: '/topics/$topicId'
      preLoaderRoute: typeof AdminTopicsTopicIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/study-helpers/$studyHelperId': {
      id: '/_admin/study-helpers/$studyHelperId'
      path: '/study-helpers/$studyHelperId'
      fullPath: '/study-helpers/$studyHelperId'
      preLoaderRoute: typeof AdminStudyHelpersStudyHelperIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/students/$studentId': {
      id: '/_admin/students/$studentId'
      path: '/students/$studentId'
      fullPath: '/students/$studentId'
      preLoaderRoute: typeof AdminStudentsStudentIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/series/$seriesId': {
      id: '/_admin/series/$seriesId'
      path: '/series/$seriesId'
      fullPath: '/series/$seriesId'
      preLoaderRoute: typeof AdminSeriesSeriesIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/quiz-submissions/$submissionId': {
      id: '/_admin/quiz-submissions/$submissionId'
      path: '/quiz-submissions/$submissionId'
      fullPath: '/quiz-submissions/$submissionId'
      preLoaderRoute: typeof AdminQuizSubmissionsSubmissionIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/questions/$questionId': {
      id: '/_admin/questions/$questionId'
      path: '/questions/$questionId'
      fullPath: '/questions/$questionId'
      preLoaderRoute: typeof AdminQuestionsQuestionIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/onboardings/$onboardingId': {
      id: '/_admin/onboardings/$onboardingId'
      path: '/onboardings/$onboardingId'
      fullPath: '/onboardings/$onboardingId'
      preLoaderRoute: typeof AdminOnboardingsOnboardingIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/lessons/$lessonId': {
      id: '/_admin/lessons/$lessonId'
      path: '/lessons/$lessonId'
      fullPath: '/lessons/$lessonId'
      preLoaderRoute: typeof AdminLessonsLessonIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/groups/$groupId': {
      id: '/_admin/groups/$groupId'
      path: '/groups/$groupId'
      fullPath: '/groups/$groupId'
      preLoaderRoute: typeof AdminGroupsGroupIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/feedbacks/$submissionId': {
      id: '/_admin/feedbacks/$submissionId'
      path: '/feedbacks/$submissionId'
      fullPath: '/feedbacks/$submissionId'
      preLoaderRoute: typeof AdminFeedbacksSubmissionIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/campaigns/$campaignId': {
      id: '/_admin/campaigns/$campaignId'
      path: '/campaigns/$campaignId'
      fullPath: '/campaigns/$campaignId'
      preLoaderRoute: typeof AdminCampaignsCampaignIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/applications/$applicationId': {
      id: '/_admin/applications/$applicationId'
      path: '/applications/$applicationId'
      fullPath: '/applications/$applicationId'
      preLoaderRoute: typeof AdminApplicationsApplicationIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/onboarding-slides/$onboardingId/$slideIndex': {
      id: '/_admin/onboarding-slides/$onboardingId/$slideIndex'
      path: '/onboarding-slides/$onboardingId/$slideIndex'
      fullPath: '/onboarding-slides/$onboardingId/$slideIndex'
      preLoaderRoute: typeof AdminOnboardingSlidesOnboardingIdSlideIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/courses/$courseId/$version': {
      id: '/_admin/courses/$courseId/$version'
      path: '/courses/$courseId/$version'
      fullPath: '/courses/$courseId/$version'
      preLoaderRoute: typeof AdminCoursesCourseIdVersionRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminRouteChildren {
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminApplicationsApplicationIdRoute: typeof AdminApplicationsApplicationIdRoute
  AdminCampaignsCampaignIdRoute: typeof AdminCampaignsCampaignIdRoute
  AdminFeedbacksSubmissionIdRoute: typeof AdminFeedbacksSubmissionIdRoute
  AdminGroupsGroupIdRoute: typeof AdminGroupsGroupIdRoute
  AdminLessonsLessonIdRoute: typeof AdminLessonsLessonIdRoute
  AdminOnboardingsOnboardingIdRoute: typeof AdminOnboardingsOnboardingIdRoute
  AdminQuestionsQuestionIdRoute: typeof AdminQuestionsQuestionIdRoute
  AdminQuizSubmissionsSubmissionIdRoute: typeof AdminQuizSubmissionsSubmissionIdRoute
  AdminSeriesSeriesIdRoute: typeof AdminSeriesSeriesIdRoute
  AdminStudentsStudentIdRoute: typeof AdminStudentsStudentIdRoute
  AdminStudyHelpersStudyHelperIdRoute: typeof AdminStudyHelpersStudyHelperIdRoute
  AdminTopicsTopicIdRoute: typeof AdminTopicsTopicIdRoute
  AdminApplicationsIndexRoute: typeof AdminApplicationsIndexRoute
  AdminCampaignsIndexRoute: typeof AdminCampaignsIndexRoute
  AdminCertificatesIndexRoute: typeof AdminCertificatesIndexRoute
  AdminCoursesIndexRoute: typeof AdminCoursesIndexRoute
  AdminFeedbacksIndexRoute: typeof AdminFeedbacksIndexRoute
  AdminGroupsIndexRoute: typeof AdminGroupsIndexRoute
  AdminLessonsIndexRoute: typeof AdminLessonsIndexRoute
  AdminOnboardingSlidesIndexRoute: typeof AdminOnboardingSlidesIndexRoute
  AdminOnboardingsIndexRoute: typeof AdminOnboardingsIndexRoute
  AdminQuestionsIndexRoute: typeof AdminQuestionsIndexRoute
  AdminQuizSubmissionsIndexRoute: typeof AdminQuizSubmissionsIndexRoute
  AdminSeriesIndexRoute: typeof AdminSeriesIndexRoute
  AdminStudentsIndexRoute: typeof AdminStudentsIndexRoute
  AdminStudyHelpersIndexRoute: typeof AdminStudyHelpersIndexRoute
  AdminTopicsIndexRoute: typeof AdminTopicsIndexRoute
  AdminCoursesCourseIdVersionRoute: typeof AdminCoursesCourseIdVersionRoute
  AdminOnboardingSlidesOnboardingIdSlideIndexRoute: typeof AdminOnboardingSlidesOnboardingIdSlideIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminApplicationsApplicationIdRoute: AdminApplicationsApplicationIdRoute,
  AdminCampaignsCampaignIdRoute: AdminCampaignsCampaignIdRoute,
  AdminFeedbacksSubmissionIdRoute: AdminFeedbacksSubmissionIdRoute,
  AdminGroupsGroupIdRoute: AdminGroupsGroupIdRoute,
  AdminLessonsLessonIdRoute: AdminLessonsLessonIdRoute,
  AdminOnboardingsOnboardingIdRoute: AdminOnboardingsOnboardingIdRoute,
  AdminQuestionsQuestionIdRoute: AdminQuestionsQuestionIdRoute,
  AdminQuizSubmissionsSubmissionIdRoute: AdminQuizSubmissionsSubmissionIdRoute,
  AdminSeriesSeriesIdRoute: AdminSeriesSeriesIdRoute,
  AdminStudentsStudentIdRoute: AdminStudentsStudentIdRoute,
  AdminStudyHelpersStudyHelperIdRoute: AdminStudyHelpersStudyHelperIdRoute,
  AdminTopicsTopicIdRoute: AdminTopicsTopicIdRoute,
  AdminApplicationsIndexRoute: AdminApplicationsIndexRoute,
  AdminCampaignsIndexRoute: AdminCampaignsIndexRoute,
  AdminCertificatesIndexRoute: AdminCertificatesIndexRoute,
  AdminCoursesIndexRoute: AdminCoursesIndexRoute,
  AdminFeedbacksIndexRoute: AdminFeedbacksIndexRoute,
  AdminGroupsIndexRoute: AdminGroupsIndexRoute,
  AdminLessonsIndexRoute: AdminLessonsIndexRoute,
  AdminOnboardingSlidesIndexRoute: AdminOnboardingSlidesIndexRoute,
  AdminOnboardingsIndexRoute: AdminOnboardingsIndexRoute,
  AdminQuestionsIndexRoute: AdminQuestionsIndexRoute,
  AdminQuizSubmissionsIndexRoute: AdminQuizSubmissionsIndexRoute,
  AdminSeriesIndexRoute: AdminSeriesIndexRoute,
  AdminStudentsIndexRoute: AdminStudentsIndexRoute,
  AdminStudyHelpersIndexRoute: AdminStudyHelpersIndexRoute,
  AdminTopicsIndexRoute: AdminTopicsIndexRoute,
  AdminCoursesCourseIdVersionRoute: AdminCoursesCourseIdVersionRoute,
  AdminOnboardingSlidesOnboardingIdSlideIndexRoute:
    AdminOnboardingSlidesOnboardingIdSlideIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AdminRoute: AdminRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
